// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* loginpage */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Container Styling */
.container-login {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    /* min-height: 100vh; */
    padding: 0;
    /* Remove padding from container */
}

.container-login .card {
    display: flex;
    width: 100%;
    height: auto !important;
    max-width: 1080px;
    /* Set the maximum width of the card */
    /* min-height: 420px; Set a minimum height for the card */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 0;
    /* Ensure no margin on the card */
    padding: 0;
    /* Ensure no padding on the card */
    border-radius: 10px;
    /* Rounded corners */
    overflow: hidden;
    /* Ensure no content overflows the card */
}

/* Row Layout */
.container-login .row {
    display: flex;
    width: 100%;
    margin: 0;
    /* Remove any row margins */
    padding: 0;
    /* Remove any row paddings */
}

/* Left Side (Image) */
.container-login .left {
    width: 50%;
    /* Set the image container to take up 50% of the card width */
    padding: 0;
    /* No padding for the left section */
}

.container-login .left .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Make sure the image covers the area */
}

.container-login .right {
    width: 50%;
    /* Set the right section to take up 50% of the card width */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f5f2e7;
    /* padding: 20px; Add padding to the form area */
    /* border-radius: 10px; Rounded corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Slight shadow around form */
}

.container-login .right h2 {
    margin-bottom: 30px;
    /* Adjust bottom margin for spacing */
    color: rgba(107, 142, 118, 1);
    width: 305px;
    height: 140px;
    top: 102px;
    left: 928px;
    gap: 0px;
    font-family: "FANTASY MAGIST";
    font-size: 45px;
    font-weight: 400;
    line-height: 69.94px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

/* Button Styles */
.container-login .right .btn {
    width: 80%;
    padding: 9px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(245, 242, 231, 1);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: rgba(107, 142, 118, 1);
    font-style: "Poppins";
    font-weight: 500;
    transition: background-color 0.3s;
}

.container-login .right .btn-outline-success {
    width: 80%;
    padding: 9px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(107, 142, 118, 1);
    border: 1px solid rgba(107, 142, 118, 1);
    background-color: transparent;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.container-login .right .btn-outline-success:hover {
    background-color: rgba(107, 142, 118, 1);
    color: #fff;
}

/* Responsive Design with Bootstrap grid system */
@media (max-width: 768px) {
    .container-login .card {
        flex-direction: column;
        /* Stack the columns vertically */
        min-height: auto;
        /* Remove fixed height for smaller screens */
    }

    .container-login .left,
    .container-login .right {
        width: 100%;
        /* Make both sections take 100% width */
        padding: 0;
        /* Remove extra padding */
    }

    .container-login .right {
        padding: 15px;
        /* Add padding to the right section */
    }

    .container-login .right h2 {
        font-size: 28px;
        /* Smaller heading for mobile */
        margin-bottom: 20px;
        /* Adjust margin for better alignment */
    }

    .container-login .right .btn {
        width: 90%;
        /* Make the buttons full-width on smaller screens */
        padding: 12px;
        /* Adjust padding */
    }

    .container-login .right .btn-outline-success {
        width: 90%;
        padding: 12px;
    }
}

@media (max-width: 576px) {
    .container-login {
        display: flex;
        justify-content: center;
        /* min-height: 100vh; */
        padding: 0;
    }

    .container-login .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 257px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 44.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    .container-login .row {
        flex-direction: column;
        /* Stack the content vertically on small screens */
    }

    .container-login .left {
        width: 100%;
        height: 40vh;
        padding: 0;
        border-radius: none;
    }

    .container-login .right {
        width: 100%;
        /* Buttons section also takes up full width */
        padding: 10px;
        height: 51vh;
    }

    .container-login .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 305px;
        height: 109px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 56.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }
}

@media (max-width: 480px) {
    .container-login .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 129px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 35px;
        font-weight: 400;
        line-height: 40.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    .container .card {
        display: flex;
        width: 91%;
        max-width: 800px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin: 0;
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 305px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 69.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    .container .right .btn {
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        font-size: 16px;
        color: rgb(245, 242, 231);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        background-color: rgb(107, 142, 118);
        font-style: "Poppins";
        font-weight: 500;
        transition: background-color 0.3s;
    }

    .row {
        flex-direction: column;
        /* Stack the content vertically on small screens */
    }

    .container-login .left {
        width: 100%;
        height: 40vh;
        padding: 0;
        border-radius: none;
    }

    .container-login .right {
        width: 100%;
        /* Buttons section also takes up full width */
        padding: 10px;
        height: 51vh;
    }

    .container-login .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 200px;
        height: 110px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 40px;
        font-weight: 400;
        line-height: 40.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }
}

@media (max-width: 380px) {
    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 205px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 25px;
        font-weight: 400;
        line-height: 32.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    .container .left .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .container .right .btn {
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        font-size: 12px;
        color: rgb(245, 242, 231);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        background-color: rgb(107, 142, 118);
        font-style: "Poppins";
        font-weight: 500;
        transition: background-color 0.3s;
    }
}

@media (max-width: 300px) {
    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 125px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 24px;
        font-weight: 400;
        line-height: 30.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }
}

/* loginwithphoneoremail */


/* Container Styling */
.container-phone-email {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    /* min-height: 100vh; */
    padding: 0;
    /* Remove padding from container */
}

.container-phone-email .card {
    display: flex;
    width: 100%;
    max-width: 1080px;
    height: auto !important;
    /* Set the maximum width of the card */
    /* min-height: 420px; */
    /* Set a minimum height for the card */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 0;
    /* Ensure no margin on the card */
    padding: 0;
    /* Ensure no padding on the card */
    border-radius: 10px;
    /* Rounded corners */
    overflow: hidden;
    /* Ensure no content overflows the card */
}

/* Row Layout */
.container-phone-email .row {
    display: flex;
    width: 100%;
    margin: 0;
    /* Remove any row margins */
    padding: 0;
    /* Remove any row paddings */
}

/* Left Side (Image) */
.container-phone-email .left {
    width: 50%;
    /* Set the image container to take up 50% of the card width */
    padding: 0;
    /* No padding for the left section */
}

.container-phone-email .left .img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    /* Make sure the image covers the area */
}

.container-phone-email .right {
    width: 50%;
    /* Set the right section to take up 50% of the card width */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f5f2e7;
    /* padding: 20px; */
    /* Add padding to the form area */
    /* border-radius: 10px; */
    /* Rounded corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Slight shadow around form */
}

.container-phone-email .right .text-center h2 {
    margin-bottom: 30px;
    /* Adjust bottom margin for spacing */
    color: rgba(107, 142, 118, 1);
    width: 100%;
    height: 140px;
    top: 102px;
    left: 928px;
    gap: 0px;
    font-family: "FANTASY MAGIST";
    font-size: 45px;
    font-weight: 400;
    line-height: 69.94px;
    text-align: center;
    /* margin-top: 16%; */
    /* text-underline-position: from-font; */
    /* text-decoration-skip-ink: none; */
}

/* CSS to add pipe sign after country code */
.container-phone-email .phone-input-container,
.container-phone-email .form-check {
    padding-left: 50px;
    padding-right: 50px;
    /* Adjust padding for country code */
}

.container-phone-email .phone-input-container .PhoneInput input:after {
    content: "|";
    position: absolute;
    left: 55px;
    /* Position pipe after the country code */
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #000;
}

/* Button Styles */
.container-phone-email .right .btn {
    width: 80%;
    padding: 15px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(245, 242, 231, 1);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: rgba(107, 142, 118, 1);
    font-style: "Poppins";
    font-weight: 500;
    transition: background-color 0.3s;
}

.container-phone-email .right .btn-outline-success {
    width: 80%;
    padding: 15px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(107, 142, 118, 1);
    border: 1px solid rgba(107, 142, 118, 1);
    background-color: transparent;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.container-phone-email .right .btn-outline-success:hover {
    background-color: rgba(107, 142, 118, 1);
    color: #fff;
}

.container-phone-email .footer {
    /* margin-top: auto; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    position: absolute;
    /* top: 16%; */
    bottom: 0;
    /* left: 0; */
    /* right: 99px; */
    /* right: -308px; */
    width: 50%;
    bottom: 16px;
}

.container-phone-email .footer .sign-link {
    /* margin-top: 14rem; */
    width: 289px;
    height: 11px;
    top: 840px;
    /* left: 936px; */
    gap: 0px;
    font-family: "Poppins";
    font-size: 11px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
}

.container-phone-email .footer .signup-instruction {
    margin-top: 5%;
    font-size: 9px;
    font-weight: 400;
    color: rgba(103, 103, 103, 1);
}

/* Responsive Design with Bootstrap grid system */
@media (max-width: 768px) {
    .container-phone-email .card {
        flex-direction: column;
        /* Stack the columns vertically */
        min-height: auto;
        /* Remove fixed height for smaller screens */
    }

    .container-phone-email .left,
    .container-phone-email .right {
        width: 100%;
        /* Make both sections take 100% width */
        padding: 0;
        /* Remove extra padding */
    }

    .container-phone-email .right {
        padding: 15px;
        /* Add padding to the right section */
    }

    .container-phone-email .right h2 {
        font-size: 28px;
        /* Smaller heading for mobile */
        margin-bottom: 20px;
        /* Adjust margin for better alignment */
    }

    .container-phone-email .right .btn {
        width: 90%;
        /* Make the buttons full-width on smaller screens */
        padding: 12px;
        /* Adjust padding */
    }

    .container-phone-email .right .btn-outline-success {
        width: 90%;
        padding: 12px;
    }
}

@media (max-width: 576px) {
    .container-phone-email .left {
        width: 100%;
        padding: 0;
    }

    .container-phone-email .right {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items: center;
        background-color: #f5f2e7;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .container-phone-email .row {
        flex-direction: column;
        /* Stack the content vertically on small screens */
    }

    .container-phone-email .left {
        width: 100%;
        height: 50vh;
        padding: 0;
        border-radius: none;
    }

    .container-phone-email .right {
        width: 100%;
        /* Buttons section also takes up full width */
        padding: 10px;
        height: 95vh;
    }

    .container-phone-email .right h2 {
        color: rgb(107, 142, 118);
        width: 305px;
        height: 109px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 56.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        margin-top: 0%;
    }
}

@media (max-width: 480px) {
    .container .card {
        display: flex;
        width: 91%;
        max-width: 800px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin: 0;
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 305px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 69.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    .container .right .btn {
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        font-size: 16px;
        color: rgb(245, 242, 231);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        background-color: rgb(107, 142, 118);
        font-style: "Poppins";
        font-weight: 500;
        transition: background-color 0.3s;
    }

    /* h2 { font-size: 24px; } Adjust for smaller font */
    .container .right .btn {
        font-size: 14px;
        /* Adjust button text size */
    }
}

@media (max-width: 380px) {
    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 205px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 25px;
        font-weight: 400;
        line-height: 32.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    .container .left .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .container .right .btn {
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        font-size: 12px;
        color: rgb(245, 242, 231);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        background-color: rgb(107, 142, 118);
        font-style: "Poppins";
        font-weight: 500;
        transition: background-color 0.3s;
    }
}

@media (max-width: 300px) {
    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 125px;
        height: 140px;
        top: 102px;
        left: 928px;
        gap: 0px;
        font-family: "FANTASY MAGIST";
        font-size: 24px;
        font-weight: 400;
        line-height: 30.94px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }
}

/* LoginWithPhoneNumber */


/* Container Styling */
.container-signup {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    /* min-height: 100vh; */
    padding: 0;
}

.container-signup .card {
    display: flex;
    width: 100%;
    height: 650px !important;
    max-width: 1080px;
    /* Set the maximum width of the card */
    /* min-height: 420px; */
    /* Set a minimum height for the card */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 0;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
}

.container-signup .row {
    display: flex;
    width: 100%;
    margin: 0;
    padding: 0;
}

.container-signup .left {
    width: 50%;
    /* Set the image container to take up 50% of the card width */
    padding: 0;
}

.container-signup .left .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Make sure the image covers the area */
}

.container-signup .right {
    width: 50%;
    /* Set the right section to take up 50% of the card width */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f5f2e7;
    /* padding: 20px; */
    /* Add padding to the form area */
    /* border-radius: 10px; */
    /* Rounded corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.container-signup .right .text-center h2 {
    margin-bottom: 30px;
    color: rgba(107, 142, 118, 1);
    width: 100%;
    height: 140px;
    top: 102px;
    left: 928px;
    gap: 0px;
    font-family: "FANTASY MAGIST";
    font-size: 45px;
    font-weight: 400;
    line-height: 69.94px;
    text-align: center;
}

.container-signup .phone-input-container,
.container-signup .form-check {
    padding-left: 50px;
    padding-right: 50px;
}

.container-signup .phone-input-container .PhoneInput input:after {
    content: "|";
    position: absolute;
    left: 55px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #000;
}

.container-signup .right .btn {
    width: 80%;
    padding: 15px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(245, 242, 231, 1);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: rgba(107, 142, 118, 1);
    font-style: "Poppins";
    font-weight: 500;
    transition: background-color 0.3s;
}

.container-signup .right .btn-outline-success {
    width: 80%;
    padding: 15px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(107, 142, 118, 1);
    border: 1px solid rgba(107, 142, 118, 1);
    background-color: transparent;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.container-signup .right .btn-outline-success:hover {
    background-color: rgba(107, 142, 118, 1);
    color: #fff;
}

.container-signup .footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    position: absolute;
    width: 50%;
    bottom: 16px;
}

.container-signup .footer .sign-link {
    width: 289px;
    height: 11px;
    font-family: "Poppins";
    font-size: 11px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
}

.container-signup .footer .signup-instruction {
    margin-top: 5%;
    font-size: 9px;
    font-weight: 400;
    color: rgba(103, 103, 103, 1);
}

@media (max-width: 768px) {
    .container-signup .card {
        flex-direction: column;
    }

    .container-signup .left,
    .container-signup .right {
        width: 100%;
        padding: 0;
    }

    .container-signup .right {
        padding: 15px;
    }

    .container-signup .right .btn {
        width: 100% !important;
        padding: 15px;
        margin: 5px 0;
        font-size: 16px;
        background-color: rgb(107, 142, 118);
    }

    .container-signup .footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        position: relative;
        margin-top: 2rem;
        width: 100% !important;
        bottom: 16px;
        right: 0px !important;
    }

    h2 {
        font-size: 28px;
        margin-bottom: 20px;
    }

    .container-signup .right .btn,
    .container-signup .right .btn-outline-success {
        width: 90%;
        padding: 12px;
    }
}

@media (max-width: 576px) {
    .container-phone-email .left {
        width: 100%;
        height: 50vh;
        padding: 0;
    }

    .container-phone-email .right {
        width: 100%;
        padding: 10px;
        height: 100vh;
    }

    .container-phone-email .right h2 {
        color: rgb(107, 142, 118);
        width: 305px;
        height: 109px;
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 56.94px;
        text-align: center;
        margin-top: 56%;
    }
}

@media (max-width: 480px) {
    .container .card {
        display: flex;
        width: 91%;
        max-width: 800px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin: 0;
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 69.94px;
        text-align: center;
    }

    .container .right .btn {
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        font-size: 16px;
        background-color: rgb(107, 142, 118);
    }

    .btn {
        font-size: 14px;
    }
}

@media (max-width: 380px) {
    .container .right h2 {
        font-size: 25px;
        font-family: "FANTASY MAGIST";
        text-align: center;
    }

    .container .left .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .container .right .btn {
        font-size: 12px;
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        background-color: rgb(107, 142, 118);
    }
}

@media (max-width: 300px) {
    .container .right h2 {
        font-size: 24px;
        font-family: "FANTASY MAGIST";
        text-align: center;
    }
}

.react-tel-input .flag-dropdown {
    position: absolute;
    top: 0px;
    bottom: 0;
    padding: 0px;
    background-color: rgb(107, 142, 118) !important;
    border: none !important;
    margin: 8px;
    padding-top: -6px;
}

sapn.phone-devider {
    position: absolute;
    top: 21.8rem;
    left: 42.9rem;
    font-size: 25px;
    color: #6b8e76;
    z-index: 1;
}

.flex {
    display: flex;
}

.flex .relative {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    border: 1px solid rgb(107, 142, 118);
    background-color: transparent;
    border-radius: 0.375rem 0 0 0.375rem;
    width: 10rem;
}

.flex .relative select {
    appearance: none;
    background-color: transparent;
    outline: none;
    font-size: 1rem;
    color: rgb(107, 142, 118);
    width: 100%;
    border: none !important;
}

.flex input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #4b5563;
    background-color: transparent;
    color: rgb(107, 142, 118);
    border-radius: 0 0.375rem 0.375rem 0;
    outline: none;
    transition: border-color 0.2s ease-in-out;
}

.flex input:focus {
    ring: 2px solid rgb(107, 142, 118);
    border-color: rgb(107, 142, 118);
}

.flex input::placeholder {
    color: rgb(107, 142, 118);
}

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-top: 0%;
    margin-bottom: 0.125rem;
    margin-right: 51%;
}

.error {
    color: red;
    font-size: 12px;
    margin-top: -9px;
    margin-right: 35%;
}

/* loginemailpage */


/* Container Styling */
.container-email {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 0;
}

.container-email .card {
    display: flex;
    flex-wrap: wrap;
    height: 650px !important;
    width: 100%;
    max-width: 1080px;
    /* Set the maximum width of the card */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;
    background-color: white;
}

/* Row Layout */
.container-email .row {
    display: flex;
    /* width: 100%; */
    flex-wrap: wrap;
}

/* Left Side (Image) */
.container-email .left {
    width: 50%;
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.container-email .left .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Right Side (Form Section) */
.container-email .right {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* Center vertically */
    align-items: center;
    /* Center horizontally */
    padding: 30px;
    background-color: #f5f2e7;
}

.container-email .right .text-center {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    /* align-items: center; */
    padding-left: 50px;
    padding-right: 50px;
}

.container-email .right .text-center h2 {
    margin-bottom: 30px;
    /* Adjust bottom margin for spacing */
    color: rgba(107, 142, 118, 1);
    width: 100%;
    height: 140px;
    top: 102px;
    left: 928px;
    gap: 0px;
    font-family: "FANTASY MAGIST";
    font-size: 45px;
    font-weight: 400;
    line-height: 69.94px;
    text-align: center;
    /* margin-top: 16%; */
    /* text-underline-position: from-font; */
    /* text-decoration-skip-ink: none; */
}

/* Form Input Styling */
.container-email .right .text-center .inputForm {
    width: 100%;
    /* max-width: 350px; */
    border: 1.5px solid rgba(107, 142, 118, 1);
    height: 50px;
    display: flex;
    align-items: center;
    margin: 10px 0;
    transition: 0.2s ease-in-out;
    border-radius: 5px;
    color: rgba(107, 142, 118, 1);
}

.container-email .right .text-center .inputForm .input {
    margin: 0 !important;
    width: 100%;
    border: none;
    height: 100%;
    font-size: 17px;
    background-color: transparent;
    font-weight: 500;
    color: rgb(107, 142, 118);
    text-align: left !important;
    padding-left: 15px;
}

.container-email .right .text-center .inputForm .input:focus {
    outline: none;
}

.container-email .right .text-center .inputForm:focus-within {
    border-color: #6b8e76;
}

/* Error Styling */
.container-email .right .text-center .error-text {
    color: red;
    font-size: 12px;
    margin-top: 5px;
    /* Space between input and error message */
    text-align: left;
    /* Aligns the error message with the input */
}

/* Flex row between 'Remember me' checkbox and 'Forgot password?' */
.container-email .right .text-center .flex-row {
    width: 100%;
    max-width: 350px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
}

.container-email .right .text-center .flex-row label {
    font-size: 14px;
    color: #151717;
}

.container-email .right .text-center .flex-row .span {
    font-size: 14px;
    color: var(--Miscellaneous-Floating-Tab---Text-Selected, rgba(0, 122, 255, 1));
    cursor: pointer;
}

/* Submit Button Styling */
.container-email .right .text-center .button-submit {
    background-color: rgba(107, 142, 118, 1);
    color: white;
    font-size: 15px;
    font-weight: 500;
    height: 50px;
    width: 100%;
    /* max-width: 350px; */
    border-radius: 10px;
    cursor: pointer;
    margin: 20px 0 10px;
    border: none;
}

/* Footer Styling */
.container-email .right .footer {
    /* margin-top: auto; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    position: absolute;
    /* top: 16%; */
    bottom: 0;
    right: 0px !important;
    width: 50%;
    bottom: 16px;
}

.container-email .right .footer .sign-link {
    /* margin-top: 14rem; */
    width: 289px;
    height: 11px;
    top: 840px;
    /* left: 936px; */
    gap: 0px;
    font-family: "Poppins";
    font-size: 11px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
}

.container-email .right .footer .signup-instruction {
    margin-top: 5%;
    font-size: 9px;
    font-weight: 400;
    color: rgba(103, 103, 103, 1);
}

/* Right Side (Form and Buttons) */
@media (max-width: 928px) {
    .container-email .right .text-center h2 {
        font-size: 44px !important;
    }
}

@media (max-width: 910px) {
    .container-email .right .text-center h2 {
        font-size: 35px !important;
    }
}

@media (max-width: 790px) {
    .container-email .right .text-center h2 {
        font-size: 34px !important;
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .container-email .card {
        display: flex;
        flex-direction: column;
        /* Stack sections vertically */
    }

    .container-email .left,
    .container-email .right {
        width: 100%;
        /* Make each section take full width */
    }

    .container-email .right {
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* Center content vertically */
        align-items: center;
        /* Center content horizontally */
        text-align: center;
    }

    .container-email .right h2 {
        font-size: 28px;
        /* Adjust font size for smaller screens */
    }

    .container-email .right .inputForm {
        width: 100%;
        max-width: 100%;
        /* Full width for smaller screens */
        margin: 10px 0;
        /* Add spacing between input fields */
    }

    .container-email .right .button-submit {
        max-width: 100%;
        /* Full width button */
        margin-top: 20px;
    }

    .container-email .right .flex-row {
        flex-direction: column;
        /* Stack 'Remember me' and 'Forgot password?' */
        align-items: flex-start;
        /* Align items to the left */
        gap: 10px;
        /* Add space between items */
        margin-top: 10px;
    }

    .container-email .right .links {
        margin-top: auto;
        /* Push links to the bottom */
    }
}

@media (max-width: 768px) {
    .container-email .left {
        width: 100%;
        padding: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .container-email .right {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 30px;
        background-color: #f5f2e7;
    }

    .container-email .right .footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        position: relative;
        margin-top: 2rem;
        /* top: 2%; */
        /* bottom: 0; */
        /* left: 0; */
        /* right: 99px; */
        /* right: -308px; */
        width: 100%;
        bottom: 16px;
        right: 0px !important;
    }
}

@media (max-width: 480px) {
    .container-email .right {
        padding: 15px;
    }

    .container-email .right h2 {
        font-size: 24px;
    }

    .container-email .right .inputForm {
        max-width: 100%;
        height: 45px;
    }

    .container-email .right .inputForm .input {
        font-size: 14px;
    }

    .container-email .right .flex-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }

    .container-email .right .button-submit {
        height: 45px;
    }

    .container-email .right .p {
        font-size: 12px;
    }
}

@media (max-width: 300px) {
    .container-email .right h2 {
        font-size: 20px;
    }

    .container-email .right .inputForm {
        height: 40px;
    }

    .container-email .right .button-submit {
        height: 40px;
    }

    .container-email .right .p {
        font-size: 10px;
    }

    .container-email .right .links {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        margin-top: 15%;
    }

    .container-email .d-flex.flex-column.links {
        padding-top: 13%;
    }
}

/* otpverificationpage */


/* Container Styling */
.container-mobileotp {
    display: flex;
    justify-content: center;
    padding: 0;
}

.container-mobileotp .card {
    width: 100%;
    max-width: 1080px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 0;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
    height: 650px !important;
}

/* Row Layout */
.container-mobileotp .row {
    width: 100%;
    margin: 0;
    padding: 0;
}

/* Left Side (Image) */
.container-mobileotp .left {
    width: 50%;
    padding: 0;
}

.container-mobileotp .left .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.container-mobileotp .right {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px;
    background-color: #f5f2e7;
}

.container-mobileotp .right .text-center {
    display: flex;
    flex-direction: column;
    padding-left: 50px;
    padding-right: 50px;
}

.container-mobileotp .right .text-center h2 {
    margin-bottom: 30px;
    color: rgba(107, 142, 118, 1);
    width: 100%;
    height: 140px;
    font-family: "FANTASY MAGIST";
    font-size: 45px;
    font-weight: 400;
    line-height: 69.94px;
    text-align: center;
}

.container-mobileotp .right .row .col-xs-12 .otp-input-fields {
    margin: auto;
    max-width: 400px;
    width: auto;
    display: flex;
    justify-content: center;
    gap: 10px;
    padding-top: 55px;
    padding-bottom: 59px;
}

.container-mobileotp .right .row .col-xs-12 .otp-input-fields input {
    height: 40px;
    width: 40px;
    background-color: transparent;
    border-radius: 4px;
    border: 1px solid #2f8f1f;
    text-align: center;
    outline: none;
    font-size: 16px;
}

.container-mobileotp .right .row .col-xs-12 .otp-input-fields input::-webkit-outer-spin-button,
.container-mobileotp .right .row .col-xs-12 .otp-input-fields input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.container-mobileotp .right .row .col-xs-12 .otp-input-fields input[type="number"] {
    -moz-appearance: textfield;
}

.container-mobileotp .right .row .col-xs-12 .otp-input-fields input:focus {
    border-width: 2px;
    border-color: darken(#2f8f1f, 5%);
    font-size: 20px;
}

.container-mobileotp .right .row .col-xs-12 .otp-resend {
    margin-top: -30px;
    font-size: 14px;
}

.container-mobileotp .right .row .col-xs-12 .otp-resend .btn-link {
    color: #007bff;
    text-decoration: none;
}

.container-mobileotp .right .row .col-xs-12 .otp-resend .btn-link:hover {
    text-decoration: underline;
}

/* Button Styles */
.container-mobileotp .right .row .col-xs-12 .btn {
    width: 100%;
    padding: 15px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(245, 242, 231, 1);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: rgba(107, 142, 118, 1);
    font-style: "Poppins";
    font-weight: 500;
    transition: background-color 0.3s;
}

.container-mobileotp .right .row .col-xs-12 .btn-outline-success {
    width: 100%;
    padding: 15px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(107, 142, 118, 1);
    border: 1px solid rgba(107, 142, 118, 1);
    background-color: transparent;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.container-mobileotp .right .row .col-xs-12 .btn-outline-success:hover {
    background-color: rgba(107, 142, 118, 1);
    color: #fff;
}

.container-mobileotp .right .footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    position: absolute;
    width: 50%;
    bottom: 16px;
    right: 0px !important;
}

.container-mobileotp .right .footer .sign-link {
    width: 289px;
    font-family: "Poppins";
    font-size: 11px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
}

.container-mobileotp .right .footer .signup-instruction {
    margin-top: 5%;
    font-size: 9px;
    font-weight: 400;
    color: rgba(103, 103, 103, 1);
}

/* Responsive Design with Bootstrap grid system */
@media (max-width: 928px) {
    .container-mobileotp .right .text-center h2 {
        font-size: 44px;
    }
}

@media (max-width: 910px) {
    .container-mobileotp .right .text-center h2 {
        font-size: 35px;
    }
}

@media (max-width: 790px) {
    .container-mobileotp .right .text-center h2 {
        font-size: 34px;
    }
}

@media (max-width: 776px) {
    .container-mobileotp .card {
        flex-direction: column;
        min-height: auto;
        font-size: 10px !important;
    }

    .container-mobileotp .left,
    .container-mobileotp .right {
        width: 100%;
        padding: 0;
    }

    .container-mobileotp .right {
        padding: 15px;
    }

    .container-mobileotp .right .footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        position: relative;
        margin-top: 2rem;
        width: 100%;
    }

    .container-mobileotp .right h2 {
        font-size: 28px;
        margin-bottom: 20px;
    }

    .container-mobileotp .right .btn {
        width: 90%;
        padding: 12px;
    }

    .container-mobileotp .right .btn-outline-success {
        width: 90%;
        padding: 12px;
    }
}

@media (max-width: 480px) {
    .container .card {
        display: flex;
        width: 91%;
        max-width: 800px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin: 0;
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 305px;
        height: 140px;
        font-family: "FANTASY MAGIST";
        font-size: 38px;
        font-weight: 400;
        line-height: 69.94px;
        text-align: center;
    }

    .container .right .btn {
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        font-size: 16px;
        color: rgb(245, 242, 231);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        background-color: rgb(107, 142, 118);
        font-style: "Poppins";
        font-weight: 500;
        transition: background-color 0.3s;
    }

    .container .right .btn-outline-success {
        width: 70%;
        padding: 15px;
    }
}

@media (max-width: 380px) {
    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 205px;
        height: 140px;
        font-family: "FANTASY MAGIST";
        font-size: 25px;
        font-weight: 400;
        line-height: 32.94px;
        text-align: center;
    }

    .container .left .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .container .right .btn {
        width: 70%;
        padding: 15px;
        margin: 10px 0;
        font-size: 12px;
        color: rgb(245, 242, 231);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        background-color: rgb(107, 142, 118);
        font-style: "Poppins";
        font-weight: 500;
        transition: background-color 0.3s;
    }
}

@media (max-width: 300px) {
    .container .right h2 {
        margin-bottom: 30px;
        color: rgb(107, 142, 118);
        width: 125px;
        height: 140px;
        font-family: "FANTASY MAGIST";
        font-size: 24px;
        font-weight: 400;
        line-height: 30.94px;
        text-align: center;
    }
}

/* signuppage */
/* Container Styling */
.container-signup {
    display: flex;
    justify-content: center;
    padding: 0;
}

.container-signup .card {
    display: flex;
    width: 100%;
    max-width: 1080px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 0;
    padding: 0;
    border-radius: 10px;
    height: 100%;
    overflow: hidden;
    height: 650px !important;
}

.container-signup .row {
    display: flex;
    width: 100%;
    margin: 0;
    padding: 0;
}

.container-signup .left {
    width: 50%;
    padding: 0;
}

.container-signup .left .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.container-signup .right {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f5f2e7;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.container-signup .right h2 {
    margin-bottom: 30px;
    color: rgba(107, 142, 118, 1);
    width: 100%;
    height: 140px;
    top: 102px;
    left: 928px;
    gap: 0px;
    font-family: "FANTASY MAGIST";
    font-size: 45px;
    font-weight: 400;
    line-height: 69.94px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.container-signup .right .btn {
    width: 80%;
    padding: 9px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(245, 242, 231, 1);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: rgba(107, 142, 118, 1);
    font-style: "Poppins";
    font-weight: 500;
    transition: background-color 0.3s;
}

.container-signup .right .btn-outline-success {
    width: 80%;
    padding: 9px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(107, 142, 118, 1);
    border: 1px solid rgba(107, 142, 118, 1);
    background-color: transparent;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.container-signup .right .btn-outline-success:hover {
    background-color: rgba(107, 142, 118, 1);
    color: #fff;
}

/* Responsive Design with Bootstrap grid system */
@media (max-width: 768px) {
    .container-signup .card {
        flex-direction: column;
        min-height: auto;
    }

    .container-signup .left,
    .container-signup .right {
        width: 100%;
        padding: 0;
    }

    .container-signup .right {
        padding: 15px;
    }

    .container-signup .right h2 {
        font-size: 28px;
        margin-bottom: 20px;
    }

    .container-signup .right .btn {
        width: 90%;
        padding: 12px;
    }

    .container-signup .right .btn-outline-success {
        width: 90%;
        padding: 12px;
    }
}

@media (max-width: 576px) {
    .container-login {
        display: flex;
        justify-content: center;
        padding: 0;
    }

    .container-signup .right h2 {
        font-size: 38px;
        line-height: 56.94px;
    }

    .container-signup .row {
        flex-direction: column;
    }

    .container-signup .left {
        height: 40vh;
    }

    .container-signup .right {
        padding: 10px;
        height: 51vh;
    }
}

@media (max-width: 546px) {
    .container-signup .right .btn {
        font-size: 16px;
    }

    .container-signup .right .btn-outline-success {
        font-size: 15px;
    }
}

@media (max-width: 519px) {
    .container-signup .right .btn-outline-success {
        font-size: 14px;
    }
}

@media (max-width: 492px) {
    .container-signup .right .btn-outline-success {
        font-size: 13px;
    }
}

@media (max-width: 465px) {
    .container-signup .right .btn-outline-success {
        font-size: 12px;
    }

    .container-signup .row {
        flex-direction: column;
    }

    .container-signup .left {
        height: 40vh;
    }

    .container-signup .right {
        height: 75vh;
    }
}

@media (max-width: 380px) {
    .container .right h2 {
        font-size: 25px;
        line-height: 32.94px;
    }

    .container .left .img {
        object-fit: cover;
    }

    .container .right .btn {
        font-size: 12px;
    }
}

@media (max-width: 300px) {
    .container .right h2 {
        font-size: 24px;
        line-height: 30.94px;
    }
}

/* signupwithlinks */
/* Container Styling */
.container-signup-with-links {
    display: flex;
    justify-content: center;
    height: auto;
    padding: 0;
}

.container-signup-with-links .card {
    display: flex;
    width: 100%;
    max-width: 1080px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 0;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
    height: 650px !important;
}

.container-signup-with-links .row {
    display: flex;
    width: 100%;
    margin: 0;
    padding: 0;
}

.container-signup-with-links .left {
    width: 50%;
    padding: 0;
}

.container-signup-with-links .left .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.container-signup-with-links .right {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f5f2e7;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.container-signup-with-links .right .heading .title {
    margin-bottom: 30px;
    color: rgba(107, 142, 118, 1);
    width: 100%;
    height: 140px;
    font-family: "FANTASY MAGIST";
    font-size: 45px;
    font-weight: 400;
    line-height: 69.94px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.container-signup-with-links .right .buttons .btn {
    width: 100%;
    padding: 9px;
    margin: 10px 0;
    font-size: 16px;
    color: rgba(107, 142, 118, 1);
    border: 1px solid rgba(107, 142, 118, 1);
    border-radius: 5px;
    cursor: pointer;
    font-style: "Poppins";
    font-weight: 500;
    transition: background-color 0.3s;
}

.container-signup-with-links .right .socials {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
}

.container-signup-with-links .right .socials .links-with-socials a {
    text-decoration: none;
    color: #007bff;
}

.container-signup-with-links .right .socials .not-a-brand .signup-link {
    color: #007bff;
    cursor: pointer;
}

.container-signup-with-links .right .socials .terms-and-conditions p {
    font-family: "Poppins", sans-serif;
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0.5px;
    color: rgba(103, 103, 103, 0.5);
}

/* signup-with-socials */
button.btn-social:hover {
    background-color: rgba(107, 142, 118, 1) !important;
    color: white !important;
}

button.btn-social:hover img {
    filter: brightness(0) invert(1);
}



/* Responsive Design */
@media (max-width: 768px) {
    .container-signup-with-links .card {
        flex-direction: column;
        min-height: auto;
    }

    .container-signup-with-links .left,
    .container-signup-with-links .right {
        width: 100%;
        padding: 0;
    }

    .container-signup-with-links .right h2 {
        font-size: 28px;
        margin-bottom: 20px;
    }

    .container-signup-with-links .right .btn {
        width: 90%;
        padding: 12px;
    }
}

@media (max-width: 576px) {
    .container-signup-with-links .row {
        flex-direction: column;
    }

    .container-signup-with-links .left {
        height: 40vh;
    }

    .container-signup-with-links .right {
        height: 51vh;
    }

    .container-signup-with-links .right h2 {
        font-size: 38px;
    }
}

@media (max-width: 380px) {
    .container-signup-with-links .right h2 {
        font-size: 25px;
    }
}`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Auth/auth.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,sCAAsC;IACtC,yDAAyD;IACzD,wCAAwC;IACxC,SAAS;IACT,iCAAiC;IACjC,UAAU;IACV,kCAAkC;IAClC,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,4BAA4B;AAChC;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,6DAA6D;IAC7D,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,2DAA2D;IAC3D,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,gDAAgD;IAChD,yCAAyC;IACzC,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,UAAU;IACV,WAAW;IACX,QAAQ;IACR,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA,kBAAkB;AAClB;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA,iDAAiD;AACjD;IACI;QACI,sBAAsB;QACtB,iCAAiC;QACjC,gBAAgB;QAChB,4CAA4C;IAChD;;IAEA;;QAEI,WAAW;QACX,uCAAuC;QACvC,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,qCAAqC;IACzC;;IAEA;QACI,eAAe;QACf,+BAA+B;QAC/B,mBAAmB;QACnB,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,mDAAmD;QACnD,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;QACtB,kDAAkD;IACtD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,6CAA6C;QAC7C,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,wCAAwC;QACxC,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,oCAAoC;QACpC,qBAAqB;QACrB,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,sBAAsB;QACtB,kDAAkD;IACtD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,6CAA6C;QAC7C,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,oCAAoC;QACpC,qBAAqB;QACrB,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;AACJ;;AAEA,0BAA0B;;;AAG1B,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,sCAAsC;IACtC,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;IACxC,SAAS;IACT,iCAAiC;IACjC,UAAU;IACV,kCAAkC;IAClC,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,4BAA4B;AAChC;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,6DAA6D;IAC7D,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,2DAA2D;IAC3D,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,oBAAoB;IACpB,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,UAAU;IACV,WAAW;IACX,QAAQ;IACR,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA,4CAA4C;AAC5C;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,yCAAyC;IACzC,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,QAAQ;IACR,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,iDAAiD;AACjD;IACI;QACI,sBAAsB;QACtB,iCAAiC;QACjC,gBAAgB;QAChB,4CAA4C;IAChD;;IAEA;;QAEI,WAAW;QACX,uCAAuC;QACvC,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,qCAAqC;IACzC;;IAEA;QACI,eAAe;QACf,+BAA+B;QAC/B,mBAAmB;QACnB,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,mDAAmD;QACnD,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,qBAAqB;QACrB,mBAAmB;QACnB,yBAAyB;QACzB,wCAAwC;IAC5C;;IAEA;QACI,sBAAsB;QACtB,kDAAkD;IACtD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,6CAA6C;QAC7C,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;QAC9B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,wCAAwC;QACxC,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,oCAAoC;QACpC,qBAAqB;QACrB,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA,oDAAoD;IACpD;QACI,eAAe;QACf,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,oCAAoC;QACpC,qBAAqB;QACrB,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,UAAU;QACV,WAAW;QACX,QAAQ;QACR,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,kCAAkC;QAClC,8BAA8B;IAClC;AACJ;;AAEA,yBAAyB;;;AAGzB,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,sCAAsC;IACtC,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;IACxC,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;IACV,6DAA6D;IAC7D,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,2DAA2D;IAC3D,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iCAAiC;IACjC,yBAAyB;IACzB,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,UAAU;IACV,WAAW;IACX,QAAQ;IACR,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,aAAa;QACb,eAAe;QACf,oCAAoC;IACxC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;;QAEI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,WAAW;QACX,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,wCAAwC;QACxC,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,oCAAoC;IACxC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,6BAA6B;QAC7B,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,aAAa;QACb,cAAc;QACd,oCAAoC;IACxC;AACJ;;AAEA;IACI;QACI,eAAe;QACf,6BAA6B;QAC7B,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,+CAA+C;IAC/C,uBAAuB;IACvB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,6BAA6B;IAC7B,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;IACzB,oCAAoC;IACpC,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,mBAAmB;;;AAGnB,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,UAAU;IACV,WAAW;IACX,QAAQ;IACR,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,sBAAsB;IACtB,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA,mEAAmE;AACnE;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,8EAA8E;IAC9E,eAAe;AACnB;;AAEA,0BAA0B;AAC1B;IACI,wCAAwC;IACxC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,qBAAqB;IACrB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,QAAQ;IACR,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,kCAAkC;AAClC;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA;;QAEI,WAAW;QACX,sCAAsC;IAC1C;;IAEA;QACI,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,mBAAmB;QACnB,gCAAgC;QAChC,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,yCAAyC;IAC7C;;IAEA;QACI,WAAW;QACX,eAAe;QACf,mCAAmC;QACnC,cAAc;QACd,qCAAqC;IACzC;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,+CAA+C;QAC/C,uBAAuB;QACvB,4BAA4B;QAC5B,SAAS;QACT,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,aAAa;QACb,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,wBAAwB;;;AAGxB,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,wCAAwC;IACxC,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,eAAe;AACf;IACI,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,iDAAiD;AACjD;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;;QAEI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,wCAAwC;QACxC,SAAS;QACT,UAAU;QACV,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,oCAAoC;QACpC,qBAAqB;QACrB,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,oCAAoC;QACpC,qBAAqB;QACrB,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;AAEA,eAAe;AACf,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,wCAAwC;IACxC,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,UAAU;IACV,WAAW;IACX,QAAQ;IACR,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;IACxC,WAAW;AACf;;AAEA,iDAAiD;AACjD;IACI;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,oBAAoB;IACxB;AACJ;;AAEA,oBAAoB;AACpB,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,wCAAwC;IACxC,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA,wBAAwB;AACxB;IACI,mDAAmD;IACnD,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;AACnC;;;;AAIA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* loginpage */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* Container Styling */\n.container-login {\n    display: flex;\n    justify-content: center;\n    /* align-items: center; */\n    /* min-height: 100vh; */\n    padding: 0;\n    /* Remove padding from container */\n}\n\n.container-login .card {\n    display: flex;\n    width: 100%;\n    height: auto !important;\n    max-width: 1080px;\n    /* Set the maximum width of the card */\n    /* min-height: 420px; Set a minimum height for the card */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin: 0;\n    /* Ensure no margin on the card */\n    padding: 0;\n    /* Ensure no padding on the card */\n    border-radius: 10px;\n    /* Rounded corners */\n    overflow: hidden;\n    /* Ensure no content overflows the card */\n}\n\n/* Row Layout */\n.container-login .row {\n    display: flex;\n    width: 100%;\n    margin: 0;\n    /* Remove any row margins */\n    padding: 0;\n    /* Remove any row paddings */\n}\n\n/* Left Side (Image) */\n.container-login .left {\n    width: 50%;\n    /* Set the image container to take up 50% of the card width */\n    padding: 0;\n    /* No padding for the left section */\n}\n\n.container-login .left .img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    /* Make sure the image covers the area */\n}\n\n.container-login .right {\n    width: 50%;\n    /* Set the right section to take up 50% of the card width */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #f5f2e7;\n    /* padding: 20px; Add padding to the form area */\n    /* border-radius: 10px; Rounded corners */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    /* Slight shadow around form */\n}\n\n.container-login .right h2 {\n    margin-bottom: 30px;\n    /* Adjust bottom margin for spacing */\n    color: rgba(107, 142, 118, 1);\n    width: 305px;\n    height: 140px;\n    top: 102px;\n    left: 928px;\n    gap: 0px;\n    font-family: \"FANTASY MAGIST\";\n    font-size: 45px;\n    font-weight: 400;\n    line-height: 69.94px;\n    text-align: center;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n/* Button Styles */\n.container-login .right .btn {\n    width: 80%;\n    padding: 9px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(245, 242, 231, 1);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: rgba(107, 142, 118, 1);\n    font-style: \"Poppins\";\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n.container-login .right .btn-outline-success {\n    width: 80%;\n    padding: 9px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(107, 142, 118, 1);\n    border: 1px solid rgba(107, 142, 118, 1);\n    background-color: transparent;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s;\n}\n\n.container-login .right .btn-outline-success:hover {\n    background-color: rgba(107, 142, 118, 1);\n    color: #fff;\n}\n\n/* Responsive Design with Bootstrap grid system */\n@media (max-width: 768px) {\n    .container-login .card {\n        flex-direction: column;\n        /* Stack the columns vertically */\n        min-height: auto;\n        /* Remove fixed height for smaller screens */\n    }\n\n    .container-login .left,\n    .container-login .right {\n        width: 100%;\n        /* Make both sections take 100% width */\n        padding: 0;\n        /* Remove extra padding */\n    }\n\n    .container-login .right {\n        padding: 15px;\n        /* Add padding to the right section */\n    }\n\n    .container-login .right h2 {\n        font-size: 28px;\n        /* Smaller heading for mobile */\n        margin-bottom: 20px;\n        /* Adjust margin for better alignment */\n    }\n\n    .container-login .right .btn {\n        width: 90%;\n        /* Make the buttons full-width on smaller screens */\n        padding: 12px;\n        /* Adjust padding */\n    }\n\n    .container-login .right .btn-outline-success {\n        width: 90%;\n        padding: 12px;\n    }\n}\n\n@media (max-width: 576px) {\n    .container-login {\n        display: flex;\n        justify-content: center;\n        /* min-height: 100vh; */\n        padding: 0;\n    }\n\n    .container-login .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 257px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 44.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n\n    .container-login .row {\n        flex-direction: column;\n        /* Stack the content vertically on small screens */\n    }\n\n    .container-login .left {\n        width: 100%;\n        height: 40vh;\n        padding: 0;\n        border-radius: none;\n    }\n\n    .container-login .right {\n        width: 100%;\n        /* Buttons section also takes up full width */\n        padding: 10px;\n        height: 51vh;\n    }\n\n    .container-login .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 305px;\n        height: 109px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 56.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n}\n\n@media (max-width: 480px) {\n    .container-login .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 129px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 35px;\n        font-weight: 400;\n        line-height: 40.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n\n    .container .card {\n        display: flex;\n        width: 91%;\n        max-width: 800px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        margin: 0;\n        padding: 0;\n        border-radius: 10px;\n        overflow: hidden;\n    }\n\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 305px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 69.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n\n    .container .right .btn {\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        font-size: 16px;\n        color: rgb(245, 242, 231);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        background-color: rgb(107, 142, 118);\n        font-style: \"Poppins\";\n        font-weight: 500;\n        transition: background-color 0.3s;\n    }\n\n    .row {\n        flex-direction: column;\n        /* Stack the content vertically on small screens */\n    }\n\n    .container-login .left {\n        width: 100%;\n        height: 40vh;\n        padding: 0;\n        border-radius: none;\n    }\n\n    .container-login .right {\n        width: 100%;\n        /* Buttons section also takes up full width */\n        padding: 10px;\n        height: 51vh;\n    }\n\n    .container-login .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 200px;\n        height: 110px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 40px;\n        font-weight: 400;\n        line-height: 40.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n}\n\n@media (max-width: 380px) {\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 205px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 25px;\n        font-weight: 400;\n        line-height: 32.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n\n    .container .left .img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    .container .right .btn {\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        font-size: 12px;\n        color: rgb(245, 242, 231);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        background-color: rgb(107, 142, 118);\n        font-style: \"Poppins\";\n        font-weight: 500;\n        transition: background-color 0.3s;\n    }\n}\n\n@media (max-width: 300px) {\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 125px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 24px;\n        font-weight: 400;\n        line-height: 30.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n}\n\n/* loginwithphoneoremail */\n\n\n/* Container Styling */\n.container-phone-email {\n    display: flex;\n    justify-content: center;\n    /* align-items: center; */\n    /* min-height: 100vh; */\n    padding: 0;\n    /* Remove padding from container */\n}\n\n.container-phone-email .card {\n    display: flex;\n    width: 100%;\n    max-width: 1080px;\n    height: auto !important;\n    /* Set the maximum width of the card */\n    /* min-height: 420px; */\n    /* Set a minimum height for the card */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin: 0;\n    /* Ensure no margin on the card */\n    padding: 0;\n    /* Ensure no padding on the card */\n    border-radius: 10px;\n    /* Rounded corners */\n    overflow: hidden;\n    /* Ensure no content overflows the card */\n}\n\n/* Row Layout */\n.container-phone-email .row {\n    display: flex;\n    width: 100%;\n    margin: 0;\n    /* Remove any row margins */\n    padding: 0;\n    /* Remove any row paddings */\n}\n\n/* Left Side (Image) */\n.container-phone-email .left {\n    width: 50%;\n    /* Set the image container to take up 50% of the card width */\n    padding: 0;\n    /* No padding for the left section */\n}\n\n.container-phone-email .left .img {\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n    /* Make sure the image covers the area */\n}\n\n.container-phone-email .right {\n    width: 50%;\n    /* Set the right section to take up 50% of the card width */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #f5f2e7;\n    /* padding: 20px; */\n    /* Add padding to the form area */\n    /* border-radius: 10px; */\n    /* Rounded corners */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    /* Slight shadow around form */\n}\n\n.container-phone-email .right .text-center h2 {\n    margin-bottom: 30px;\n    /* Adjust bottom margin for spacing */\n    color: rgba(107, 142, 118, 1);\n    width: 100%;\n    height: 140px;\n    top: 102px;\n    left: 928px;\n    gap: 0px;\n    font-family: \"FANTASY MAGIST\";\n    font-size: 45px;\n    font-weight: 400;\n    line-height: 69.94px;\n    text-align: center;\n    /* margin-top: 16%; */\n    /* text-underline-position: from-font; */\n    /* text-decoration-skip-ink: none; */\n}\n\n/* CSS to add pipe sign after country code */\n.container-phone-email .phone-input-container,\n.container-phone-email .form-check {\n    padding-left: 50px;\n    padding-right: 50px;\n    /* Adjust padding for country code */\n}\n\n.container-phone-email .phone-input-container .PhoneInput input:after {\n    content: \"|\";\n    position: absolute;\n    left: 55px;\n    /* Position pipe after the country code */\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 16px;\n    color: #000;\n}\n\n/* Button Styles */\n.container-phone-email .right .btn {\n    width: 80%;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(245, 242, 231, 1);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: rgba(107, 142, 118, 1);\n    font-style: \"Poppins\";\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n.container-phone-email .right .btn-outline-success {\n    width: 80%;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(107, 142, 118, 1);\n    border: 1px solid rgba(107, 142, 118, 1);\n    background-color: transparent;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s;\n}\n\n.container-phone-email .right .btn-outline-success:hover {\n    background-color: rgba(107, 142, 118, 1);\n    color: #fff;\n}\n\n.container-phone-email .footer {\n    /* margin-top: auto; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    position: absolute;\n    /* top: 16%; */\n    bottom: 0;\n    /* left: 0; */\n    /* right: 99px; */\n    /* right: -308px; */\n    width: 50%;\n    bottom: 16px;\n}\n\n.container-phone-email .footer .sign-link {\n    /* margin-top: 14rem; */\n    width: 289px;\n    height: 11px;\n    top: 840px;\n    /* left: 936px; */\n    gap: 0px;\n    font-family: \"Poppins\";\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: center;\n}\n\n.container-phone-email .footer .signup-instruction {\n    margin-top: 5%;\n    font-size: 9px;\n    font-weight: 400;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* Responsive Design with Bootstrap grid system */\n@media (max-width: 768px) {\n    .container-phone-email .card {\n        flex-direction: column;\n        /* Stack the columns vertically */\n        min-height: auto;\n        /* Remove fixed height for smaller screens */\n    }\n\n    .container-phone-email .left,\n    .container-phone-email .right {\n        width: 100%;\n        /* Make both sections take 100% width */\n        padding: 0;\n        /* Remove extra padding */\n    }\n\n    .container-phone-email .right {\n        padding: 15px;\n        /* Add padding to the right section */\n    }\n\n    .container-phone-email .right h2 {\n        font-size: 28px;\n        /* Smaller heading for mobile */\n        margin-bottom: 20px;\n        /* Adjust margin for better alignment */\n    }\n\n    .container-phone-email .right .btn {\n        width: 90%;\n        /* Make the buttons full-width on smaller screens */\n        padding: 12px;\n        /* Adjust padding */\n    }\n\n    .container-phone-email .right .btn-outline-success {\n        width: 90%;\n        padding: 12px;\n    }\n}\n\n@media (max-width: 576px) {\n    .container-phone-email .left {\n        width: 100%;\n        padding: 0;\n    }\n\n    .container-phone-email .right {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: left;\n        align-items: center;\n        background-color: #f5f2e7;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    }\n\n    .container-phone-email .row {\n        flex-direction: column;\n        /* Stack the content vertically on small screens */\n    }\n\n    .container-phone-email .left {\n        width: 100%;\n        height: 50vh;\n        padding: 0;\n        border-radius: none;\n    }\n\n    .container-phone-email .right {\n        width: 100%;\n        /* Buttons section also takes up full width */\n        padding: 10px;\n        height: 95vh;\n    }\n\n    .container-phone-email .right h2 {\n        color: rgb(107, 142, 118);\n        width: 305px;\n        height: 109px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 56.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n        margin-top: 0%;\n    }\n}\n\n@media (max-width: 480px) {\n    .container .card {\n        display: flex;\n        width: 91%;\n        max-width: 800px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        margin: 0;\n        padding: 0;\n        border-radius: 10px;\n        overflow: hidden;\n    }\n\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 305px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 69.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n\n    .container .right .btn {\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        font-size: 16px;\n        color: rgb(245, 242, 231);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        background-color: rgb(107, 142, 118);\n        font-style: \"Poppins\";\n        font-weight: 500;\n        transition: background-color 0.3s;\n    }\n\n    /* h2 { font-size: 24px; } Adjust for smaller font */\n    .container .right .btn {\n        font-size: 14px;\n        /* Adjust button text size */\n    }\n}\n\n@media (max-width: 380px) {\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 205px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 25px;\n        font-weight: 400;\n        line-height: 32.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n\n    .container .left .img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    .container .right .btn {\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        font-size: 12px;\n        color: rgb(245, 242, 231);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        background-color: rgb(107, 142, 118);\n        font-style: \"Poppins\";\n        font-weight: 500;\n        transition: background-color 0.3s;\n    }\n}\n\n@media (max-width: 300px) {\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 125px;\n        height: 140px;\n        top: 102px;\n        left: 928px;\n        gap: 0px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 24px;\n        font-weight: 400;\n        line-height: 30.94px;\n        text-align: center;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n    }\n}\n\n/* LoginWithPhoneNumber */\n\n\n/* Container Styling */\n.container-signup {\n    display: flex;\n    justify-content: center;\n    /* align-items: center; */\n    /* min-height: 100vh; */\n    padding: 0;\n}\n\n.container-signup .card {\n    display: flex;\n    width: 100%;\n    height: 650px !important;\n    max-width: 1080px;\n    /* Set the maximum width of the card */\n    /* min-height: 420px; */\n    /* Set a minimum height for the card */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin: 0;\n    padding: 0;\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.container-signup .row {\n    display: flex;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n.container-signup .left {\n    width: 50%;\n    /* Set the image container to take up 50% of the card width */\n    padding: 0;\n}\n\n.container-signup .left .img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    /* Make sure the image covers the area */\n}\n\n.container-signup .right {\n    width: 50%;\n    /* Set the right section to take up 50% of the card width */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #f5f2e7;\n    /* padding: 20px; */\n    /* Add padding to the form area */\n    /* border-radius: 10px; */\n    /* Rounded corners */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.container-signup .right .text-center h2 {\n    margin-bottom: 30px;\n    color: rgba(107, 142, 118, 1);\n    width: 100%;\n    height: 140px;\n    top: 102px;\n    left: 928px;\n    gap: 0px;\n    font-family: \"FANTASY MAGIST\";\n    font-size: 45px;\n    font-weight: 400;\n    line-height: 69.94px;\n    text-align: center;\n}\n\n.container-signup .phone-input-container,\n.container-signup .form-check {\n    padding-left: 50px;\n    padding-right: 50px;\n}\n\n.container-signup .phone-input-container .PhoneInput input:after {\n    content: \"|\";\n    position: absolute;\n    left: 55px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 16px;\n    color: #000;\n}\n\n.container-signup .right .btn {\n    width: 80%;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(245, 242, 231, 1);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: rgba(107, 142, 118, 1);\n    font-style: \"Poppins\";\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n.container-signup .right .btn-outline-success {\n    width: 80%;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(107, 142, 118, 1);\n    border: 1px solid rgba(107, 142, 118, 1);\n    background-color: transparent;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s;\n}\n\n.container-signup .right .btn-outline-success:hover {\n    background-color: rgba(107, 142, 118, 1);\n    color: #fff;\n}\n\n.container-signup .footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    position: absolute;\n    width: 50%;\n    bottom: 16px;\n}\n\n.container-signup .footer .sign-link {\n    width: 289px;\n    height: 11px;\n    font-family: \"Poppins\";\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: center;\n}\n\n.container-signup .footer .signup-instruction {\n    margin-top: 5%;\n    font-size: 9px;\n    font-weight: 400;\n    color: rgba(103, 103, 103, 1);\n}\n\n@media (max-width: 768px) {\n    .container-signup .card {\n        flex-direction: column;\n    }\n\n    .container-signup .left,\n    .container-signup .right {\n        width: 100%;\n        padding: 0;\n    }\n\n    .container-signup .right {\n        padding: 15px;\n    }\n\n    .container-signup .right .btn {\n        width: 100% !important;\n        padding: 15px;\n        margin: 5px 0;\n        font-size: 16px;\n        background-color: rgb(107, 142, 118);\n    }\n\n    .container-signup .footer {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n        align-items: center;\n        position: relative;\n        margin-top: 2rem;\n        width: 100% !important;\n        bottom: 16px;\n        right: 0px !important;\n    }\n\n    h2 {\n        font-size: 28px;\n        margin-bottom: 20px;\n    }\n\n    .container-signup .right .btn,\n    .container-signup .right .btn-outline-success {\n        width: 90%;\n        padding: 12px;\n    }\n}\n\n@media (max-width: 576px) {\n    .container-phone-email .left {\n        width: 100%;\n        height: 50vh;\n        padding: 0;\n    }\n\n    .container-phone-email .right {\n        width: 100%;\n        padding: 10px;\n        height: 100vh;\n    }\n\n    .container-phone-email .right h2 {\n        color: rgb(107, 142, 118);\n        width: 305px;\n        height: 109px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 56.94px;\n        text-align: center;\n        margin-top: 56%;\n    }\n}\n\n@media (max-width: 480px) {\n    .container .card {\n        display: flex;\n        width: 91%;\n        max-width: 800px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        margin: 0;\n        padding: 0;\n        border-radius: 10px;\n        overflow: hidden;\n    }\n\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 69.94px;\n        text-align: center;\n    }\n\n    .container .right .btn {\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        font-size: 16px;\n        background-color: rgb(107, 142, 118);\n    }\n\n    .btn {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 380px) {\n    .container .right h2 {\n        font-size: 25px;\n        font-family: \"FANTASY MAGIST\";\n        text-align: center;\n    }\n\n    .container .left .img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    .container .right .btn {\n        font-size: 12px;\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        background-color: rgb(107, 142, 118);\n    }\n}\n\n@media (max-width: 300px) {\n    .container .right h2 {\n        font-size: 24px;\n        font-family: \"FANTASY MAGIST\";\n        text-align: center;\n    }\n}\n\n.react-tel-input .flag-dropdown {\n    position: absolute;\n    top: 0px;\n    bottom: 0;\n    padding: 0px;\n    background-color: rgb(107, 142, 118) !important;\n    border: none !important;\n    margin: 8px;\n    padding-top: -6px;\n}\n\nsapn.phone-devider {\n    position: absolute;\n    top: 21.8rem;\n    left: 42.9rem;\n    font-size: 25px;\n    color: #6b8e76;\n    z-index: 1;\n}\n\n.flex {\n    display: flex;\n}\n\n.flex .relative {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    padding: 0.5rem 0.75rem;\n    border: 1px solid rgb(107, 142, 118);\n    background-color: transparent;\n    border-radius: 0.375rem 0 0 0.375rem;\n    width: 10rem;\n}\n\n.flex .relative select {\n    appearance: none;\n    background-color: transparent;\n    outline: none;\n    font-size: 1rem;\n    color: rgb(107, 142, 118);\n    width: 100%;\n    border: none !important;\n}\n\n.flex input {\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #4b5563;\n    background-color: transparent;\n    color: rgb(107, 142, 118);\n    border-radius: 0 0.375rem 0.375rem 0;\n    outline: none;\n    transition: border-color 0.2s ease-in-out;\n}\n\n.flex input:focus {\n    ring: 2px solid rgb(107, 142, 118);\n    border-color: rgb(107, 142, 118);\n}\n\n.flex input::placeholder {\n    color: rgb(107, 142, 118);\n}\n\n.form-check {\n    display: block;\n    min-height: 1.5rem;\n    padding-left: 1.5em;\n    margin-top: 0%;\n    margin-bottom: 0.125rem;\n    margin-right: 51%;\n}\n\n.error {\n    color: red;\n    font-size: 12px;\n    margin-top: -9px;\n    margin-right: 35%;\n}\n\n/* loginemailpage */\n\n\n/* Container Styling */\n.container-email {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    padding: 0;\n}\n\n.container-email .card {\n    display: flex;\n    flex-wrap: wrap;\n    height: 650px !important;\n    width: 100%;\n    max-width: 1080px;\n    /* Set the maximum width of the card */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    overflow: hidden;\n    background-color: white;\n}\n\n/* Row Layout */\n.container-email .row {\n    display: flex;\n    /* width: 100%; */\n    flex-wrap: wrap;\n}\n\n/* Left Side (Image) */\n.container-email .left {\n    width: 50%;\n    padding: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.container-email .left .img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n/* Right Side (Form Section) */\n.container-email .right {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    /* Center vertically */\n    align-items: center;\n    /* Center horizontally */\n    padding: 30px;\n    background-color: #f5f2e7;\n}\n\n.container-email .right .text-center {\n    display: flex;\n    flex-direction: column;\n    /* justify-content: center; */\n    /* align-items: center; */\n    padding-left: 50px;\n    padding-right: 50px;\n}\n\n.container-email .right .text-center h2 {\n    margin-bottom: 30px;\n    /* Adjust bottom margin for spacing */\n    color: rgba(107, 142, 118, 1);\n    width: 100%;\n    height: 140px;\n    top: 102px;\n    left: 928px;\n    gap: 0px;\n    font-family: \"FANTASY MAGIST\";\n    font-size: 45px;\n    font-weight: 400;\n    line-height: 69.94px;\n    text-align: center;\n    /* margin-top: 16%; */\n    /* text-underline-position: from-font; */\n    /* text-decoration-skip-ink: none; */\n}\n\n/* Form Input Styling */\n.container-email .right .text-center .inputForm {\n    width: 100%;\n    /* max-width: 350px; */\n    border: 1.5px solid rgba(107, 142, 118, 1);\n    height: 50px;\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n    transition: 0.2s ease-in-out;\n    border-radius: 5px;\n    color: rgba(107, 142, 118, 1);\n}\n\n.container-email .right .text-center .inputForm .input {\n    margin: 0 !important;\n    width: 100%;\n    border: none;\n    height: 100%;\n    font-size: 17px;\n    background-color: transparent;\n    font-weight: 500;\n    color: rgb(107, 142, 118);\n    text-align: left !important;\n    padding-left: 15px;\n}\n\n.container-email .right .text-center .inputForm .input:focus {\n    outline: none;\n}\n\n.container-email .right .text-center .inputForm:focus-within {\n    border-color: #6b8e76;\n}\n\n/* Error Styling */\n.container-email .right .text-center .error-text {\n    color: red;\n    font-size: 12px;\n    margin-top: 5px;\n    /* Space between input and error message */\n    text-align: left;\n    /* Aligns the error message with the input */\n}\n\n/* Flex row between 'Remember me' checkbox and 'Forgot password?' */\n.container-email .right .text-center .flex-row {\n    width: 100%;\n    max-width: 350px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 10px 0;\n}\n\n.container-email .right .text-center .flex-row label {\n    font-size: 14px;\n    color: #151717;\n}\n\n.container-email .right .text-center .flex-row .span {\n    font-size: 14px;\n    color: var(--Miscellaneous-Floating-Tab---Text-Selected, rgba(0, 122, 255, 1));\n    cursor: pointer;\n}\n\n/* Submit Button Styling */\n.container-email .right .text-center .button-submit {\n    background-color: rgba(107, 142, 118, 1);\n    color: white;\n    font-size: 15px;\n    font-weight: 500;\n    height: 50px;\n    width: 100%;\n    /* max-width: 350px; */\n    border-radius: 10px;\n    cursor: pointer;\n    margin: 20px 0 10px;\n    border: none;\n}\n\n/* Footer Styling */\n.container-email .right .footer {\n    /* margin-top: auto; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    position: absolute;\n    /* top: 16%; */\n    bottom: 0;\n    right: 0px !important;\n    width: 50%;\n    bottom: 16px;\n}\n\n.container-email .right .footer .sign-link {\n    /* margin-top: 14rem; */\n    width: 289px;\n    height: 11px;\n    top: 840px;\n    /* left: 936px; */\n    gap: 0px;\n    font-family: \"Poppins\";\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: center;\n}\n\n.container-email .right .footer .signup-instruction {\n    margin-top: 5%;\n    font-size: 9px;\n    font-weight: 400;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* Right Side (Form and Buttons) */\n@media (max-width: 928px) {\n    .container-email .right .text-center h2 {\n        font-size: 44px !important;\n    }\n}\n\n@media (max-width: 910px) {\n    .container-email .right .text-center h2 {\n        font-size: 35px !important;\n    }\n}\n\n@media (max-width: 790px) {\n    .container-email .right .text-center h2 {\n        font-size: 34px !important;\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .container-email .card {\n        display: flex;\n        flex-direction: column;\n        /* Stack sections vertically */\n    }\n\n    .container-email .left,\n    .container-email .right {\n        width: 100%;\n        /* Make each section take full width */\n    }\n\n    .container-email .right {\n        padding: 20px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        /* Center content vertically */\n        align-items: center;\n        /* Center content horizontally */\n        text-align: center;\n    }\n\n    .container-email .right h2 {\n        font-size: 28px;\n        /* Adjust font size for smaller screens */\n    }\n\n    .container-email .right .inputForm {\n        width: 100%;\n        max-width: 100%;\n        /* Full width for smaller screens */\n        margin: 10px 0;\n        /* Add spacing between input fields */\n    }\n\n    .container-email .right .button-submit {\n        max-width: 100%;\n        /* Full width button */\n        margin-top: 20px;\n    }\n\n    .container-email .right .flex-row {\n        flex-direction: column;\n        /* Stack 'Remember me' and 'Forgot password?' */\n        align-items: flex-start;\n        /* Align items to the left */\n        gap: 10px;\n        /* Add space between items */\n        margin-top: 10px;\n    }\n\n    .container-email .right .links {\n        margin-top: auto;\n        /* Push links to the bottom */\n    }\n}\n\n@media (max-width: 768px) {\n    .container-email .left {\n        width: 100%;\n        padding: 0px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .container-email .right {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding: 30px;\n        background-color: #f5f2e7;\n    }\n\n    .container-email .right .footer {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n        align-items: center;\n        position: relative;\n        margin-top: 2rem;\n        /* top: 2%; */\n        /* bottom: 0; */\n        /* left: 0; */\n        /* right: 99px; */\n        /* right: -308px; */\n        width: 100%;\n        bottom: 16px;\n        right: 0px !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .container-email .right {\n        padding: 15px;\n    }\n\n    .container-email .right h2 {\n        font-size: 24px;\n    }\n\n    .container-email .right .inputForm {\n        max-width: 100%;\n        height: 45px;\n    }\n\n    .container-email .right .inputForm .input {\n        font-size: 14px;\n    }\n\n    .container-email .right .flex-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n\n    .container-email .right .button-submit {\n        height: 45px;\n    }\n\n    .container-email .right .p {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 300px) {\n    .container-email .right h2 {\n        font-size: 20px;\n    }\n\n    .container-email .right .inputForm {\n        height: 40px;\n    }\n\n    .container-email .right .button-submit {\n        height: 40px;\n    }\n\n    .container-email .right .p {\n        font-size: 10px;\n    }\n\n    .container-email .right .links {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        margin-top: 15%;\n    }\n\n    .container-email .d-flex.flex-column.links {\n        padding-top: 13%;\n    }\n}\n\n/* otpverificationpage */\n\n\n/* Container Styling */\n.container-mobileotp {\n    display: flex;\n    justify-content: center;\n    padding: 0;\n}\n\n.container-mobileotp .card {\n    width: 100%;\n    max-width: 1080px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin: 0;\n    padding: 0;\n    border-radius: 10px;\n    overflow: hidden;\n    height: 650px !important;\n}\n\n/* Row Layout */\n.container-mobileotp .row {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n/* Left Side (Image) */\n.container-mobileotp .left {\n    width: 50%;\n    padding: 0;\n}\n\n.container-mobileotp .left .img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.container-mobileotp .right {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 30px;\n    background-color: #f5f2e7;\n}\n\n.container-mobileotp .right .text-center {\n    display: flex;\n    flex-direction: column;\n    padding-left: 50px;\n    padding-right: 50px;\n}\n\n.container-mobileotp .right .text-center h2 {\n    margin-bottom: 30px;\n    color: rgba(107, 142, 118, 1);\n    width: 100%;\n    height: 140px;\n    font-family: \"FANTASY MAGIST\";\n    font-size: 45px;\n    font-weight: 400;\n    line-height: 69.94px;\n    text-align: center;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-input-fields {\n    margin: auto;\n    max-width: 400px;\n    width: auto;\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    padding-top: 55px;\n    padding-bottom: 59px;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-input-fields input {\n    height: 40px;\n    width: 40px;\n    background-color: transparent;\n    border-radius: 4px;\n    border: 1px solid #2f8f1f;\n    text-align: center;\n    outline: none;\n    font-size: 16px;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-input-fields input::-webkit-outer-spin-button,\n.container-mobileotp .right .row .col-xs-12 .otp-input-fields input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-input-fields input[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-input-fields input:focus {\n    border-width: 2px;\n    border-color: darken(#2f8f1f, 5%);\n    font-size: 20px;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-resend {\n    margin-top: -30px;\n    font-size: 14px;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-resend .btn-link {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.container-mobileotp .right .row .col-xs-12 .otp-resend .btn-link:hover {\n    text-decoration: underline;\n}\n\n/* Button Styles */\n.container-mobileotp .right .row .col-xs-12 .btn {\n    width: 100%;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(245, 242, 231, 1);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: rgba(107, 142, 118, 1);\n    font-style: \"Poppins\";\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n.container-mobileotp .right .row .col-xs-12 .btn-outline-success {\n    width: 100%;\n    padding: 15px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(107, 142, 118, 1);\n    border: 1px solid rgba(107, 142, 118, 1);\n    background-color: transparent;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s;\n}\n\n.container-mobileotp .right .row .col-xs-12 .btn-outline-success:hover {\n    background-color: rgba(107, 142, 118, 1);\n    color: #fff;\n}\n\n.container-mobileotp .right .footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    position: absolute;\n    width: 50%;\n    bottom: 16px;\n    right: 0px !important;\n}\n\n.container-mobileotp .right .footer .sign-link {\n    width: 289px;\n    font-family: \"Poppins\";\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: center;\n}\n\n.container-mobileotp .right .footer .signup-instruction {\n    margin-top: 5%;\n    font-size: 9px;\n    font-weight: 400;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* Responsive Design with Bootstrap grid system */\n@media (max-width: 928px) {\n    .container-mobileotp .right .text-center h2 {\n        font-size: 44px;\n    }\n}\n\n@media (max-width: 910px) {\n    .container-mobileotp .right .text-center h2 {\n        font-size: 35px;\n    }\n}\n\n@media (max-width: 790px) {\n    .container-mobileotp .right .text-center h2 {\n        font-size: 34px;\n    }\n}\n\n@media (max-width: 776px) {\n    .container-mobileotp .card {\n        flex-direction: column;\n        min-height: auto;\n        font-size: 10px !important;\n    }\n\n    .container-mobileotp .left,\n    .container-mobileotp .right {\n        width: 100%;\n        padding: 0;\n    }\n\n    .container-mobileotp .right {\n        padding: 15px;\n    }\n\n    .container-mobileotp .right .footer {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n        align-items: center;\n        position: relative;\n        margin-top: 2rem;\n        width: 100%;\n    }\n\n    .container-mobileotp .right h2 {\n        font-size: 28px;\n        margin-bottom: 20px;\n    }\n\n    .container-mobileotp .right .btn {\n        width: 90%;\n        padding: 12px;\n    }\n\n    .container-mobileotp .right .btn-outline-success {\n        width: 90%;\n        padding: 12px;\n    }\n}\n\n@media (max-width: 480px) {\n    .container .card {\n        display: flex;\n        width: 91%;\n        max-width: 800px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        margin: 0;\n        padding: 0;\n        border-radius: 10px;\n        overflow: hidden;\n    }\n\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 305px;\n        height: 140px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 38px;\n        font-weight: 400;\n        line-height: 69.94px;\n        text-align: center;\n    }\n\n    .container .right .btn {\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        font-size: 16px;\n        color: rgb(245, 242, 231);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        background-color: rgb(107, 142, 118);\n        font-style: \"Poppins\";\n        font-weight: 500;\n        transition: background-color 0.3s;\n    }\n\n    .container .right .btn-outline-success {\n        width: 70%;\n        padding: 15px;\n    }\n}\n\n@media (max-width: 380px) {\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 205px;\n        height: 140px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 25px;\n        font-weight: 400;\n        line-height: 32.94px;\n        text-align: center;\n    }\n\n    .container .left .img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    .container .right .btn {\n        width: 70%;\n        padding: 15px;\n        margin: 10px 0;\n        font-size: 12px;\n        color: rgb(245, 242, 231);\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        background-color: rgb(107, 142, 118);\n        font-style: \"Poppins\";\n        font-weight: 500;\n        transition: background-color 0.3s;\n    }\n}\n\n@media (max-width: 300px) {\n    .container .right h2 {\n        margin-bottom: 30px;\n        color: rgb(107, 142, 118);\n        width: 125px;\n        height: 140px;\n        font-family: \"FANTASY MAGIST\";\n        font-size: 24px;\n        font-weight: 400;\n        line-height: 30.94px;\n        text-align: center;\n    }\n}\n\n/* signuppage */\n/* Container Styling */\n.container-signup {\n    display: flex;\n    justify-content: center;\n    padding: 0;\n}\n\n.container-signup .card {\n    display: flex;\n    width: 100%;\n    max-width: 1080px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin: 0;\n    padding: 0;\n    border-radius: 10px;\n    height: 100%;\n    overflow: hidden;\n    height: 650px !important;\n}\n\n.container-signup .row {\n    display: flex;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n.container-signup .left {\n    width: 50%;\n    padding: 0;\n}\n\n.container-signup .left .img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.container-signup .right {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #f5f2e7;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.container-signup .right h2 {\n    margin-bottom: 30px;\n    color: rgba(107, 142, 118, 1);\n    width: 100%;\n    height: 140px;\n    top: 102px;\n    left: 928px;\n    gap: 0px;\n    font-family: \"FANTASY MAGIST\";\n    font-size: 45px;\n    font-weight: 400;\n    line-height: 69.94px;\n    text-align: center;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n.container-signup .right .btn {\n    width: 80%;\n    padding: 9px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(245, 242, 231, 1);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: rgba(107, 142, 118, 1);\n    font-style: \"Poppins\";\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n.container-signup .right .btn-outline-success {\n    width: 80%;\n    padding: 9px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(107, 142, 118, 1);\n    border: 1px solid rgba(107, 142, 118, 1);\n    background-color: transparent;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s;\n}\n\n.container-signup .right .btn-outline-success:hover {\n    background-color: rgba(107, 142, 118, 1);\n    color: #fff;\n}\n\n/* Responsive Design with Bootstrap grid system */\n@media (max-width: 768px) {\n    .container-signup .card {\n        flex-direction: column;\n        min-height: auto;\n    }\n\n    .container-signup .left,\n    .container-signup .right {\n        width: 100%;\n        padding: 0;\n    }\n\n    .container-signup .right {\n        padding: 15px;\n    }\n\n    .container-signup .right h2 {\n        font-size: 28px;\n        margin-bottom: 20px;\n    }\n\n    .container-signup .right .btn {\n        width: 90%;\n        padding: 12px;\n    }\n\n    .container-signup .right .btn-outline-success {\n        width: 90%;\n        padding: 12px;\n    }\n}\n\n@media (max-width: 576px) {\n    .container-login {\n        display: flex;\n        justify-content: center;\n        padding: 0;\n    }\n\n    .container-signup .right h2 {\n        font-size: 38px;\n        line-height: 56.94px;\n    }\n\n    .container-signup .row {\n        flex-direction: column;\n    }\n\n    .container-signup .left {\n        height: 40vh;\n    }\n\n    .container-signup .right {\n        padding: 10px;\n        height: 51vh;\n    }\n}\n\n@media (max-width: 546px) {\n    .container-signup .right .btn {\n        font-size: 16px;\n    }\n\n    .container-signup .right .btn-outline-success {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 519px) {\n    .container-signup .right .btn-outline-success {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 492px) {\n    .container-signup .right .btn-outline-success {\n        font-size: 13px;\n    }\n}\n\n@media (max-width: 465px) {\n    .container-signup .right .btn-outline-success {\n        font-size: 12px;\n    }\n\n    .container-signup .row {\n        flex-direction: column;\n    }\n\n    .container-signup .left {\n        height: 40vh;\n    }\n\n    .container-signup .right {\n        height: 75vh;\n    }\n}\n\n@media (max-width: 380px) {\n    .container .right h2 {\n        font-size: 25px;\n        line-height: 32.94px;\n    }\n\n    .container .left .img {\n        object-fit: cover;\n    }\n\n    .container .right .btn {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 300px) {\n    .container .right h2 {\n        font-size: 24px;\n        line-height: 30.94px;\n    }\n}\n\n/* signupwithlinks */\n/* Container Styling */\n.container-signup-with-links {\n    display: flex;\n    justify-content: center;\n    height: auto;\n    padding: 0;\n}\n\n.container-signup-with-links .card {\n    display: flex;\n    width: 100%;\n    max-width: 1080px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin: 0;\n    padding: 0;\n    border-radius: 10px;\n    overflow: hidden;\n    height: 650px !important;\n}\n\n.container-signup-with-links .row {\n    display: flex;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n.container-signup-with-links .left {\n    width: 50%;\n    padding: 0;\n}\n\n.container-signup-with-links .left .img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.container-signup-with-links .right {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #f5f2e7;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.container-signup-with-links .right .heading .title {\n    margin-bottom: 30px;\n    color: rgba(107, 142, 118, 1);\n    width: 100%;\n    height: 140px;\n    font-family: \"FANTASY MAGIST\";\n    font-size: 45px;\n    font-weight: 400;\n    line-height: 69.94px;\n    text-align: center;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n.container-signup-with-links .right .buttons .btn {\n    width: 100%;\n    padding: 9px;\n    margin: 10px 0;\n    font-size: 16px;\n    color: rgba(107, 142, 118, 1);\n    border: 1px solid rgba(107, 142, 118, 1);\n    border-radius: 5px;\n    cursor: pointer;\n    font-style: \"Poppins\";\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n.container-signup-with-links .right .socials {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 50px;\n}\n\n.container-signup-with-links .right .socials .links-with-socials a {\n    text-decoration: none;\n    color: #007bff;\n}\n\n.container-signup-with-links .right .socials .not-a-brand .signup-link {\n    color: #007bff;\n    cursor: pointer;\n}\n\n.container-signup-with-links .right .socials .terms-and-conditions p {\n    font-family: \"Poppins\", sans-serif;\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 15px;\n    letter-spacing: 0.5px;\n    color: rgba(103, 103, 103, 0.5);\n}\n\n/* signup-with-socials */\nbutton.btn-social:hover {\n    background-color: rgba(107, 142, 118, 1) !important;\n    color: white !important;\n}\n\nbutton.btn-social:hover img {\n    filter: brightness(0) invert(1);\n}\n\n\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .container-signup-with-links .card {\n        flex-direction: column;\n        min-height: auto;\n    }\n\n    .container-signup-with-links .left,\n    .container-signup-with-links .right {\n        width: 100%;\n        padding: 0;\n    }\n\n    .container-signup-with-links .right h2 {\n        font-size: 28px;\n        margin-bottom: 20px;\n    }\n\n    .container-signup-with-links .right .btn {\n        width: 90%;\n        padding: 12px;\n    }\n}\n\n@media (max-width: 576px) {\n    .container-signup-with-links .row {\n        flex-direction: column;\n    }\n\n    .container-signup-with-links .left {\n        height: 40vh;\n    }\n\n    .container-signup-with-links .right {\n        height: 51vh;\n    }\n\n    .container-signup-with-links .right h2 {\n        font-size: 38px;\n    }\n}\n\n@media (max-width: 380px) {\n    .container-signup-with-links .right h2 {\n        font-size: 25px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
